import { useEffect } from "react";

export function signInURL(
  returnTo = window.location.pathname + window.location.search + window.location.hash,
) {
  return `/auth/login?return_to=${encodeURIComponent(returnTo)}`;
}
export function useDocumentTitle(title: string) {
  useEffect(() => {
    document.title = `${title} · SSBD Access`;
  }, [title]);
}
